module.exports = __webpack_public_path__ + "static/media/stepThree.7c5ffad5.png";